/* eslint-disable react/no-array-index-key */
import { cloneElement } from 'react';

const ModalActions = (props) => {
  let { children = [] } = props;

  if (!Array.isArray(children)) {
    children = [children];
  }

  return (
    <div className="modal__actions">
      {children.map((child, n) => cloneElement(child, { key: n, className: 'modal__actionItem' }))}
    </div>
  );
};

export default ModalActions;
